import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PageResponse } from './page-response';

const API_URL = '/cargo/api/users';

export interface Country {
  id: number;
  nameRu: string;
  nameEn: string;
  code: string;
}

export interface Industry {
  id: number;
  nameRu: string;
  nameEn: string;
}

export interface Role {
  id: number;
  name: string;
  code: string;
}

export interface RoleDto {
  id: number;
  name: string;
  code: string;
}

export interface UserProfile {
  id: number;
  fullName: string;
  phone?: string;
  email: string;
  comment?: string;
  role: Role;
  companyName?: string;
  country?: Country;
  industry?: Industry;
  createdAt?: string;
  updatedAt?: string;
}

// Для админки
export interface UserDto {
  id: number;
  fullName: string;
  phone?: string;
  email: string;
  comment?: string;
  createdAt?: string;
  updatedAt?: string;
  deleted?: boolean;
  createdByUser?: number;
  updatedByUser?: number;
  role?: RoleDto;
}

export interface CreateUpdateUserRequest {
  fullName: string;
  email: string;
  phone?: string;
  comment?: string;
  password?: string;
  roleId?: number;
}

export interface SearchUsersParams {
  searchTerm?: string;
  page?: number;
  size?: number;
}

// Экспортируем также как User для обратной совместимости
export type User = UserProfile;

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private http: HttpClient) {}

  // Для профиля текущего пользователя
  getCurrentUser(): Observable<UserProfile> {
    return this.http.get<UserProfile>(`${API_URL}/current`);
  }

  // Методы для админки
  getUsers(): Observable<UserDto[]> {
    return this.http.get<UserDto[]>(API_URL);
  }

  getUser(id: number): Observable<UserDto> {
    return this.http.get<UserDto>(`${API_URL}/${id}`);
  }

  searchUsers(params: SearchUsersParams): Observable<PageResponse<UserDto>> {
    let httpParams = new HttpParams();
    if (params.searchTerm) {
      httpParams = httpParams.set('searchTerm', params.searchTerm);
    }
    if (params.page !== undefined) {
      httpParams = httpParams.set('page', params.page.toString());
    }
    if (params.size !== undefined) {
      httpParams = httpParams.set('size', params.size.toString());
    }
    return this.http.get<PageResponse<UserDto>>(`${API_URL}/search`, { params: httpParams });
  }

  createUser(request: CreateUpdateUserRequest): Observable<UserDto> {
    return this.http.post<UserDto>(API_URL, request);
  }

  updateUser(id: number, request: CreateUpdateUserRequest): Observable<UserDto> {
    return this.http.put<UserDto>(`${API_URL}/${id}`, request);
  }

  deleteUser(id: number): Observable<UserDto> {
    return this.http.delete<UserDto>(`${API_URL}/${id}`);
  }

  // Самостоятельное удаление собственного аккаунта
  deleteCurrentUser(): Observable<void> {
    return this.http.delete<void>(`${API_URL}/current`);
  }
}
